<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <g clip-path="url(#eye-closed-icon)">
        <path
          fill="inherit"
          stroke="none"
          d="M3.425 2.574a.6.6 0 1 0-.85.85l4.2 4.198a9.716 9.716 0 0 0-4.039 6.055.6.6 0 1 0 1.176.245 8.508 8.508 0 0 1 3.729-5.434l1.903 1.903a4.2 4.2 0 1 0 5.863 5.863l5.168 5.17a.6.6 0 1 0 .85-.85l-18-18ZM14.543 15.39a3 3 0 1 1-4.135-4.135l4.135 4.135Zm-2.394-5.788 4.049 4.048a4.2 4.2 0 0 0-4.049-4.048ZM12 7.199c-.684 0-1.355.089-1.999.256l-.964-.964A9.178 9.178 0 0 1 12 6c4.432 0 8.33 3.208 9.264 7.678a.6.6 0 0 1-1.176.245c-.818-3.93-4.24-6.723-8.088-6.723Z"
        />
      </g>
      <defs>
        <clipPath id="eye-closed-icon"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath>
      </defs>
    </svg>
  </span>
</template>
